module.exports = __webpack_public_path__ + "img/pax-8-logo.fe3af3cb.png";